const enums = {
    roles: {
        clinic: 'Clinic',
        hq: 'HQ',
        groupAdmin: 'Group Admin',
        superAdmin: 'Super admin'
    },
    designators: ['None', 'AM', 'PM']
}

export default enums
